// utils/slugify.js
export default function slugify(text) {
  return text
    .toLowerCase()
    .trim()
    .replace(/[_\s]+/g, "-")
    .replace(/[^\w-]+/g, "");
}
